// translates an object with query key/value pairs and replaces them with a QueryString
const getQueryString = (query: any): string =>
  Object.entries(query).reduce<string>(
    (prevValue, [queryParamName, queryParamValue]): string => `${prevValue ? `${prevValue}&` : '?'}${queryParamName}=${queryParamValue}`,
    '',
  );

export default getQueryString;
